module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addToken":"Create new token"},"de":{"addToken":"Neuen Token erstellen"},"fr":{"addToken":"Créer un nouveau token"},"it":{"addToken":"Creare un nuovo token"}}')
  delete Component.options._Ctor
}
